import { useEffect, useState } from 'react';
import { apiClient } from '../../../lib/apiClient';
import type { OverviewMetricsSummary } from '../../../types/overviewMetrics';

interface UseOverviewMetricsArgs {
  slug: string;
  startDate: string;
  endDate: string;
}

interface UseOverviewMetricsResult {
  data: OverviewMetricsSummary | null;
  loading: boolean;
  error: string | null;
}

export function useOverviewMetrics({
  slug,
  startDate,
  endDate,
}: UseOverviewMetricsArgs): UseOverviewMetricsResult {
  const [data, setData] = useState<OverviewMetricsSummary | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    apiClient
      .post<OverviewMetricsSummary>('/overview-metrics/summary', {
        slug,
        startDate,
        endDate,
      })
      .then((res) => {
        if (cancelled) return;
        setData(res);
        setLoading(false);
      })
      .catch((e: unknown) => {
        if (cancelled) return;
        setError(e instanceof Error ? e.message : 'Failed to load metrics');
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [slug, startDate, endDate]);

  return { data, loading, error };
}
